const config = {
  key: {
    ONBOARDING_COMPLETE_KEY: "onboarding_complete",
    ACCESS_TOKEN_KEY: "accessToken",
    ACCESS_TOKEN_TYPE: "bearer",
    ACCESS_TOKEN_EXPIRES_KEY: "accessTokenExpires",
    ACCOUNT_VERIFIED: "verified",
    ACCOUNT_PROFILE: "__irep_account_profile",
  },
};

export default config;

